const tableCols = [
    {
        field : 'CO1_ID',
        header : 'ID',
        visible : true,
        filter : true,
        sort : true,
        tooltip : 'Company ID',
        export : { visible : true, checked : true },
        width : 5
    },
    {
        field: 'COMPANY_NAME',
        header: 'Company',
        visible: true,
        filter: true,
        sort: true,
        tooltip: 'Company',
        export: {visible: true, checked: true},
        width: 50
    },
    {
        field: 'TICKETS',
        header: '# of Tickets',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Number of Tickets',
        export: {visible: true, checked: true},
        width: 25
    },
    {
        field: 'AGENT_REPLIES',
        header: 'Agent Replies',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Comparatio (agent) Replies',
        export: {visible: true, checked: true},
        width: 25
    },
    {
        field: 'CUSTOMER_REPLIES',
        header: 'Customer Replies',
        visible: true,
        filter: false,
        sort: true,
        tooltip: 'Customer Replies',
        export: {visible: true, checked: true},
        width: 25
    },
    {
        field : 'TOTAL_MESSAGES',
        header : 'Total Replies',
        visible : true,
        filter : false,
        sort : true,
        tooltip : 'Total Replies',
        export : { visible : true, checked : true },
        width : 20
    }
];
export default tableCols;



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/teamwork-reports/teamwork-reports.cols.ts